import { LANG, toTranslatedLanguageOrUndefined } from '@naturalcycles/shared'

export function getUrlLang(): LANG | undefined {
  return toTranslatedLanguageOrUndefined(location.pathname.split('/')[1])
}
